// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1ft5j","errors":"Errors_errors__-0GY_"};